import { UPDATE_EMPLOYEE_APP_DATA, UPDATE_DASHBOARD_FILTERS_APP_DATA } from './appData.actions';
import { EmployeeDashboardTabs } from '../../EmployeeDashboard/FilterSelectionBar';

/** @type {EmployeeAppData.IAppData} */
const initialState = {
    employeeDashboardFilters: {
        selectedTab: EmployeeDashboardTabs.Active,
        search: '',
    },
    bidProfiles: [],
    selectionTemplates: [],
    assignedShiftlines: [],
};

/**
 * @param {EmployeeAppData.IAppData} state
 * @param {ShiftBidding.ILoadEmployeeAppDataAction} action
 * */
export default function employeeAppDataReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_EMPLOYEE_APP_DATA:
            return {
                ...state,
                ...payload,
            };
        case UPDATE_DASHBOARD_FILTERS_APP_DATA:
            return {
                ...state,
                employeeDashboardFilters: {
                    ...state.employeeDashboardFilters,
                    ...payload,
                },
            };
        default:
            return state;
    }
}
